module.exports = __webpack_public_path__ + "img/pencil-white.944073b4.svg";